"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmDictionaryManager = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const _routeSearch_1 = __importStar(require("@front/pages/settings/social-media-gate/_routeSearch"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="cs-dict-manager p-3">
    <div class="cs-dict-header">
        <h4>${'settings.socialMedia.dictionary.title'.t()}</h4>
        <div class="cs-dict-tabs">
            <button type="button" class="btn btn-sm ${x => x.activeType === 'tone' ? 'btn-primary' : 'btn-outline-secondary'}" @click="${x => x.setActiveType('tone')}">${'settings.socialMedia.dictionary.type.tone'.t()}</button>
            <button type="button" class="btn btn-sm ${x => x.activeType === 'goal' ? 'btn-primary' : 'btn-outline-secondary'}" @click="${x => x.setActiveType('goal')}">${'settings.socialMedia.dictionary.type.goal'.t()}</button>
            <button type="button" class="btn btn-sm ${x => x.activeType === 'audience' ? 'btn-primary' : 'btn-outline-secondary'}" @click="${x => x.setActiveType('audience')}">${'settings.socialMedia.dictionary.type.audience'.t()}</button>
        </div>
    </div>

    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader block="true" width="20" height="20"></app-loader>`)}

    ${(0, fast_element_1.when)(x => !x.loading, (0, fast_element_1.html) `
    <div class="table-responsive">
        <table class="table table-hover table-sm align-middle">
            <thead class="table-light">
                <tr>
                    <th scope="col" ?hidden="${x => x.activeType !== 'goal'}" style="width:50px;">${'settings.socialMedia.dictionary.icon'.t()}</th>
                    <th scope="col">${'settings.socialMedia.dictionary.label'.t()}</th>
                    <th scope="col" style="width:120px;">${'settings.socialMedia.dictionary.key'.t()}</th>
                    <th scope="col" style="width:90px;">${'settings.socialMedia.dictionary.active'.t()}</th>
                    <th scope="col" style="width:90px;">${'actions'.t()}</th>
                </tr>
            </thead>
            <tbody>
                ${(0, fast_element_1.repeat)(x => x.items, (0, fast_element_1.html) `
                <tr>
                    <td ?hidden="${(x, c) => c.parent.activeType !== 'goal'}"><i class="${item => item.icon}"></i></td>
                    <td>${item => item.label}</td>
                    <td style="font-size:.75rem;color:var(--cs-ink-400);">${item => item.key}</td>
                    <td>
                        <span class="status-pill ${item => item.active ? 'on' : 'off'}"><span class="dot"></span>${item => item.active ? 'settings.status.active'.t() : 'settings.status.inactive'.t()}</span>
                    </td>
                    <td>
                        <div class="d-flex" style="gap:4px;">
                            <button type="button" class="btn btn-outline-secondary btn-sm" @click="${(item, c) => c.parent.startEdit(item)}" title="${'settings.socialMedia.dictionary.edit'.t()}"><i class="simple-icon-pencil"></i></button>
                            <button type="button" class="btn btn-outline-danger btn-sm" @click="${(item, c) => c.parent.deleteItem(item)}" title="${'settings.socialMedia.dictionary.delete'.t()}"><i class="simple-icon-trash"></i></button>
                        </div>
                    </td>
                </tr>
                `)}
            </tbody>
        </table>
    </div>

    <div class="mt-3">
        <button type="button" class="btn btn-primary btn-sm" @click="${x => x.startAdd()}" ?disabled="${x => x.showForm}"><i class="simple-icon-plus"></i> ${'settings.socialMedia.dictionary.add'.t()}</button>
    </div>

    ${(0, fast_element_1.when)(x => x.showForm, (0, fast_element_1.html) `
    <div class="cs-dict-form mt-3 pc-card">
        <h5>${x => x.editingItem ? 'settings.socialMedia.dictionary.editTitle'.t() : 'settings.socialMedia.dictionary.addTitle'.t()}</h5>
        <div class="row">
            <div class="col-md-2 mb-2">
                <div class="pc-label">${'settings.socialMedia.dictionary.type'.t()}</div>
                <input type="text" class="form-control" :value="${x => ('settings.socialMedia.dictionary.type.' + x.form.type).t()}" disabled>
            </div>
            <div class="col-md-2 mb-2">
                <div class="pc-label">${'settings.socialMedia.dictionary.key'.t()}</div>
                <input type="text" class="form-control" :value="${x => x.form.key}" @input="${(x, c) => { x.form = { ...x.form, key: c.event.target.value }; }}">
            </div>
            <div class="col-md-4 mb-2">
                <div class="pc-label">${'settings.socialMedia.dictionary.label'.t()}</div>
                <input type="text" class="form-control" :value="${x => x.form.label}" @input="${(x, c) => { x.form = { ...x.form, label: c.event.target.value }; }}">
            </div>
            ${(0, fast_element_1.when)(x => x.activeType === 'goal', (0, fast_element_1.html) `
                <div class="col-md-2 mb-2">
                    <div class="pc-label">${'settings.socialMedia.dictionary.icon'.t()}</div>
                    <icon-picker side="top" :value="${x => x.form.icon}" @icon-changed="${(x, c) => { x.form = { ...x.form, icon: c.event.detail.value }; }}" placeholder="iconsminds-idea"></icon-picker>
                </div>
            `)}
        </div>
        <div class="row">
            <div class="col-md-12 mb-2">
                <label class="d-flex align-items-center gap-2">
                    <input type="checkbox" :checked="${x => x.form.active}" @change="${(x, c) => { x.form = { ...x.form, active: c.event.target.checked }; }}">
                    ${'settings.socialMedia.dictionary.active'.t()}
                </label>
            </div>
        </div>
        <div class="d-flex gap-2">
            <button type="button" class="btn btn-primary btn-sm" @click="${x => x.saveItem()}" ?disabled="${x => x.saving}">
                ${(0, fast_element_1.when)(x => x.saving, (0, fast_element_1.html) `<app-loader block="true" width="14" height="14"></app-loader>`)}
                ${'settings.socialMedia.dictionary.save'.t()}
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" @click="${x => x.cancelEdit()}">${'settings.socialMedia.dictionary.cancel'.t()}</button>
        </div>
    </div>
    `)}
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
}

.cs-dict-manager {
  margin-top: 1.5rem;
}

.cs-dict-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.cs-dict-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cs-ink-800);
}

.cs-dict-tabs {
  display: flex;
  gap: 6px;
}

.cs-dict-form {
  background: var(--cs-bg);
  border: 1px solid var(--cs-ink-100);
  border-radius: var(--cs-radius-md);
  padding: 1rem;
}
.cs-dict-form label {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--cs-ink-500);
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
  display: block;
}`;
const shadowOptions = { "mode": "open" };
let SmDictionaryManager = class SmDictionaryManager extends client_1.RWSViewComponent {
    constructor(routeSearchService, popupService) {
        super();
        this.routeSearchService = routeSearchService;
        this.popupService = popupService;
        this.loading = false;
        this.saving = false;
        this.showForm = false;
        this.items = [];
        this.editingItem = null;
        this.form = {
            type: 'tone',
            key: '',
            label: '',
            icon: '',
            active: true
        };
        this.activeType = 'tone';
        this.proxy = false;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadItems();
    }
    activeTypeChanged() {
        this.loadItems();
    }
    async loadItems() {
        this.loading = true;
        try {
            const response = this.proxy
                ? await this.routeSearchService.callGatedBackend('social-media-dictionary.list', undefined, undefined, 'GET')
                : await this.apiService.back.get('social-media-dictionary.list', { queryParams: { activeOnly: 'true' } });
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                this.items = response.data.filter(item => item.type === this.activeType);
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.dictionary.loadFailed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to load dictionaries:', error);
            this.notifyService.notify('settings.socialMedia.dictionary.loadFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    setActiveType(type) {
        this.activeType = type;
        this.showForm = false;
    }
    startAdd() {
        this.editingItem = null;
        this.form = {
            type: this.activeType,
            key: '',
            label: '',
            icon: '',
            active: true
        };
        this.showForm = true;
    }
    startEdit(item) {
        var _a;
        this.editingItem = item;
        this.form = {
            type: item.type,
            key: item.key,
            label: item.label,
            icon: item.icon || '',
            active: (_a = item.active) !== null && _a !== void 0 ? _a : true
        };
        this.showForm = true;
    }
    cancelEdit() {
        this.editingItem = null;
        this.showForm = false;
        this.form = {
            type: this.activeType,
            key: '',
            label: '',
            icon: '',
            active: true
        };
    }
    async saveItem() {
        if (!this.form.key || !this.form.label) {
            this.notifyService.notify('settings.socialMedia.dictionary.fillRequired'.t(), 'warning');
            return;
        }
        this.saving = true;
        try {
            let response;
            if (this.editingItem) {
                response = this.proxy
                    ? await this.routeSearchService.callGatedBackend('social-media-dictionary.update', { id: String(this.editingItem.id) }, this.form, 'PUT')
                    : await this.apiService.back.put('social-media-dictionary.update', this.form, { routeParams: { id: String(this.editingItem.id) } });
            }
            else {
                response = this.proxy
                    ? await this.routeSearchService.callGatedBackend('social-media-dictionary.create', undefined, this.form, 'POST')
                    : await this.apiService.back.post('social-media-dictionary.create', this.form);
            }
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.notifyService.notify('settings.socialMedia.dictionary.saved'.t(), 'info');
                this.cancelEdit();
                await this.loadItems();
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.dictionary.saveFailed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to save dictionary:', error);
            this.notifyService.notify('settings.socialMedia.dictionary.saveFailed'.t(), 'error');
        }
        finally {
            this.saving = false;
        }
    }
    async deleteItem(item) {
        const confirmed = await this.popupService.confirm('settings.socialMedia.dictionary.deleteConfirm'.t());
        if (!confirmed)
            return;
        try {
            const response = this.proxy
                ? await this.routeSearchService.callGatedBackend('social-media-dictionary.delete', { id: String(item.id) }, undefined, 'DELETE')
                : await this.apiService.back.delete('social-media-dictionary.delete', { routeParams: { id: String(item.id) } });
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.notifyService.notify('settings.socialMedia.dictionary.deleted'.t(), 'info');
                await this.loadItems();
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.socialMedia.dictionary.deleteFailed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to delete dictionary:', error);
            this.notifyService.notify('settings.socialMedia.dictionary.deleteFailed'.t(), 'error');
        }
    }
};
exports.SmDictionaryManager = SmDictionaryManager;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmDictionaryManager.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmDictionaryManager.prototype, "saving", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], SmDictionaryManager.prototype, "showForm", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], SmDictionaryManager.prototype, "items", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.ISocialMediaDictionary !== "undefined" && backendImport_1.ISocialMediaDictionary) === "function" ? _c : Object)
], SmDictionaryManager.prototype, "editingItem", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.ISocialMediaDictionaryPayload !== "undefined" && backendImport_1.ISocialMediaDictionaryPayload) === "function" ? _d : Object)
], SmDictionaryManager.prototype, "form", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], SmDictionaryManager.prototype, "activeType", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], SmDictionaryManager.prototype, "proxy", void 0);
exports.SmDictionaryManager = SmDictionaryManager = __decorate([
    (0, client_1.RWSView)('sm-dictionary-manager', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(_routeSearch_1.default)),
    __param(1, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof _routeSearch_1.RouteSearchServiceInstance !== "undefined" && _routeSearch_1.RouteSearchServiceInstance) === "function" ? _a : Object, typeof (_b = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _b : Object])
], SmDictionaryManager);
SmDictionaryManager.defineComponent();
